import { testDriveMember } from "../mockMembers";
import { getMockPolicies } from "../builders/getMockPolicies";

import { MockPersona } from "./mockPersonas.types";

const futurePolicy = getMockPolicies("CD829471-02");

export const jamesKirk: MockPersona = {
  key: "jamesKirk",
  name: "James T. Kirk",
  description: "🇨🇦 | Future policy, no bills, no HDC",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: [],
        canada: futurePolicy,
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "james@kirk.com",
            firstName: "James",
            middleName: "Tiberius",
            lastName: "Kirk",
            mailingAddress: {
              line1: "193 George St",
              line2: "",
              city: "Sarnia",
              state: "ON",
              postalCode: "N7T 4N6",
              country: "CANADA",
            },
            preferredPhone: "4161568230",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000033",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: testDriveMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
